import mergeObject from '../../scripts/lib/mergeObject';
import defaultText from '../../config';
import objectToArray from '../../scripts/lib/objectToArray';

function makeValidConfig(cnf, defaultText) {

    /*const newcnf = mergeObject({}, cnf);
    delete newcnf.vendorList;//is an array in cnf and object in defaultText
    mergeObject(newcnf, defaultText);*/
    //if(cnf.code === 'it') debugger;
    let newcnf = mergeObject({}, defaultText);

    if (cnf && typeof (cnf.vendorList) == 'undefined') {
        //debugger;
        delete cnf.vendorList;
        //cnf.vendorList = mergeObject({}, defaultText.vendorList);
    }
    newcnf = mergeObject(newcnf, cnf);

    //basic
    //const newcnf = mergeObject(defaultText, cnf);

    /*if(newcnf && typeof(newcnf.vendorList) == 'undefined'){
        debugger;
        delete newcnf.vendorList;
    }*/
    //const vendorList = ((newcnf && !!newcnf.vendorList && newcnf.vendorList) || defaultText.vendorList);
    //debugger;

    const vendorList = cnf?.vendorList || defaultText.vendorList;
    newcnf.vendorList.purposes = objectToArray(vendorList.purposes);
    newcnf.vendorList.specialPurposes = objectToArray(vendorList.specialPurposes);
    newcnf.vendorList.features = objectToArray(vendorList.features);
    newcnf.vendorList.specialFeatures = objectToArray(vendorList.specialFeatures);
    newcnf.vendorList.consentMode = objectToArray(vendorList.consentMode);
    newcnf.vendorList.vendors = objectToArray(vendorList.vendors);

    return newcnf;
}

export const setConfiguration = (config = null, languageCode) => {
    return async dispatch => {
        let currentLanguageId = 0;

        if (config && !config.languages) config.languages = [{code: 'en'}]//supportedLanguage
        if (!config.defaultLanguage) config.defaultLanguage = 'en';

        const domesticLanguages = {};
        for (let index = 0; index < config.languages.length; index++) {
            let language = config.languages[index].code;
            if (!defaultText[language]) language = 'en';

            let languageSet = false;
            if (config.domesticPolicy) {
                //console.log(defaultText);
                if (defaultText[language + "-dom"] && !domesticLanguages[language + "-dom"]) {
                    //debugger;
                    //domesticLanguages[language+"-dom"] = makeValidConfig(config.languages[index], defaultText[language+"-dom"]);//as reference => this will collide with the default language code!
                    let textObj = null;
                    if (config.languages[index].text) {//allow for site specific overwrite's
                        textObj = {
                            /*title: config.languages[index].text.title,*/
                            /*intro: config.languages[index].text.intro*/
                            ...config.languages[index].text,
                        };
                    }
                    domesticLanguages[language + "-dom"] = makeValidConfig({
                        code: config.languages[index].code,
                        text: textObj,
                        vendorList: {...config.languages[index].vendorList, vendors: config.vendorList?.vendors || []}
                    }, defaultText[language + "-dom"]);//as clone
                    //domesticLanguages[language+"-dom"].code = language+"-dom";

                    //overwrite default language object, assume we never need it in this CMP instance
                    config.languages[index] = domesticLanguages[language + "-dom"];
                    languageSet = true;
                }
            }


            if (!languageSet) {
                config.languages[index] = makeValidConfig(config.languages[index], defaultText[language]);
            }

            /*
            config.languages[index] = mergeObject(defaultText[language], config.languages[index]);

            // Convert object to array
            config.languages[index].vendorList.purposes = objectToArray(config.languages[index].vendorList.purposes);
            config.languages[index].vendorList.specialPurposes = objectToArray(config.languages[index].vendorList.specialPurposes);
            config.languages[index].vendorList.features = objectToArray(config.languages[index].vendorList.features);
            config.languages[index].vendorList.specialFeatures = objectToArray(config.languages[index].vendorList.specialFeatures);
            config.languages[index].vendorList.vendors = objectToArray(config.languages[index].vendorList.vendors);
            */


            if (!languageCode) {
                if (config.defaultLanguage === language) currentLanguageId = index;
            } else {
                if (language === languageCode) currentLanguageId = index;
            }
        }

        let languageObj = config.languages[currentLanguageId];
        config.vendorList = {...languageObj.vendorList, vendors: config.vendorList?.vendors || []}

        if (config.domesticPolicy && domesticLanguages[config.languages[currentLanguageId].code + "-dom"]) {
            languageObj = domesticLanguages[config.languages[currentLanguageId].code + "-dom"];
            //config.languages.push(languageObj);
        }

        config.domesticLanguages = domesticLanguages;
        dispatch(setLanguage(languageObj));
        dispatch({type: 'SET_CONFIG', payload: config});

    };
};

export const setLanguage = language => {
    return {
        type: 'SET_LANGUAGE',
        payload: language
    }
};

export const setConsent = vendorConsent => {
    return {
        type: 'SET_CONSENT',
        payload: vendorConsent
    }
}

export const setAllConsentSwitch = value => {
    return {
        type: 'SETALL_CONSENTSWITCH',
        payload: value
    }
}

export const setPurposeConsent = purposeConsent => {
    return {
        type: 'SET_PURPOSECONSENT',
        payload: purposeConsent
    }
}

export const setPurposeLegitimateInterest = purposeLegitimateInterest => {
    return {
        type: 'SET_PURPOSELEGITIMATEINTEREST',
        payload: purposeLegitimateInterest
    }
}

export const setObjectConsent = objectConsent => {
    return {
        type: 'SET_OBJECTCONSENT',
        payload: objectConsent
    }
}

export const setAllObjectConsentSwitch = objectConsent => {
    return {
        type: 'SETALL_OBJECTCONSENTSWITCH',
        payload: objectConsent
    }
}

export const setSpecialFeatureConsent = specialFeatureConsent => {
    return {
        type: 'SET_SPECIALFEATURESCONSENT',
        payload: specialFeatureConsent
    }
}

export const setConsentMode = consentModeConsent => {
    return {
        type: 'SET_CONSENTMODECONSENT',
        payload: consentModeConsent
    }
}

export const toggleLanguageMenu = isOpen => {
    return {
        type: 'TOGGLE_LANGUAGEMENU',
        payload: isOpen
    }
};

export const setScreen = screen => {
    return {
        type: 'SET_SCREEN',
        payload: screen
    }
};

export const setFilter = filter => {
    return {
        type: 'SET_FILTER',
        payload: filter
    }
};

export const setHeight = height => {
    return {
        type: 'SET_HEIGHT',
        payload: height
    }
}